import { gql } from '@apollo/client';
import { APP_DOMAIN } from 'appenv';
import { fetchAllPage } from 'network/common/cmsUtils';
import { CommonLocalizableString } from 'network/common/cmsFragment';

const CommonBoothTiers = `
  ${CommonLocalizableString}
  fragment CommonBoothTiers on BoothTierConnection {
    nodes {
      id
      name {
        ...CommonLocalizableString
      }
      nameVisible
      scale {
        dimension
        unit
      }
    }
  }
`;

const fetchBoothTiersQuery = gql`
  query fetchBoothTiers(
    $domain: String!,
    $count: Int,
    $cursor: String,
    $locales: [Locale!]!
  ) {
    data: eventByDomain(domain: $domain) {
      id
      boothTiers(first: $count, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        ...CommonBoothTiers
      }
    }
  }

  ${CommonBoothTiers}
`;

export interface FetchBoothTiersQueryProps {
  domain?: string;
  count?: number;
  cursor?: string;
  locales?: string[];
}

const fetchBoothTiers = async (config: FetchBoothTiersQueryProps) => {
  const pages = await fetchAllPage(
    (data: any) => data.data.boothTiers.pageInfo,
    fetchBoothTiersQuery,
    {
      count: 20,
      domain: APP_DOMAIN,
      ...config,
    },
  );

  const boothTiers = pages
    .flatMap((page) => page.data.boothTiers.nodes);

  const result = {
    id: pages[0].data.id,
    boothTiers,
  };

  return result;
};

export default fetchBoothTiers;
